import { useProjectId } from "hooks/useProjectId";
import classes from "./classes.module.scss";
import CreativeSourceResponseResource from "common/resources/Project/Config/CreativeSource/CreativeSourceResponseResource";
import { useEffect, useState } from "react";
import { container } from "tsyringe";
import CreativeSourceService from "services/projects/CreativeSourceService";
import ProjectCreativeSource from "./ProjectCreativeSource";

const creativeSourceService = container.resolve(CreativeSourceService);

export default function ProjectCreativeSources() {
	const { creativeSources } = useCreativeSources();

	return (
		<div className={classes["root"]}>
			{creativeSources.map((creativeSource) => (
				<ProjectCreativeSource key={creativeSource.id} creativeSource={creativeSource} />
			))}
		</div>
	);
}

const useCreativeSources = () => {
	const { projectId } = useProjectId();
	const [creativeSources, setCreativeSources] = useState<CreativeSourceResponseResource[]>([]);

	useEffect(() => {
		creativeSourceService.getAllByProjectId(projectId).then(setCreativeSources);
	}, [projectId]);

	return { creativeSources };
};
